var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _path11, _path12, _circle2, _rect, _path13, _rect2, _path14, _rect3, _path15, _path16, _rect4, _circle3, _path17, _circle4, _path18, _rect5, _rect6, _rect7, _rect8, _rect9, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "projects",
    xmlns: "http://www.w3.org/2000/svg",
    width: 869.454,
    height: 372.418,
    viewBox: "0 0 869.454 372.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M306.838,473.829a8.316,8.316,0,1,0-16.551,1.093L266.4,506.21a11.584,11.584,0,0,0,1.566,12.719l1.874,2.186,8.6-1.72,9.746-8.6-1.147-9.746,12.039-18.919-.016-.014A8.309,8.309,0,0,0,306.838,473.829Z",
    transform: "translate(-115.999 -266.066)",
    fill: "#ffb9b9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M29.368,416.684l-3.9-14.485L79.48,380.265l5.756,21.377Z",
    transform: "translate(-3.748 -55.961)",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M102.832,655.192l-12.574-46.7.591-.159a18.827,18.827,0,0,1,23.073,13.283h0l7.68,28.525Z",
    transform: "translate(-90.258 -286.996)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M115.185,409.933l-12.131-8.822,28.255-50.99,17.9,13.02Z",
    transform: "translate(-15.166 -51.525)",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M194.387,662.009l-39.116-28.447.36-.495a18.827,18.827,0,0,1,26.3-4.154h0l23.891,17.375Z",
    transform: "translate(-99.825 -289.591)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M309.753,562.495l-30.527-29.655a15.416,15.416,0,0,0-20.185-1.128L201.4,595.745l5.16,8.026L261.6,566.507l37.264,48.73,35.544-17.772Z",
    transform: "translate(-106.614 -275.341)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M303.693,574.123l-22.359-1.72-16.192-3.925a8.317,8.317,0,1,0-1.578,10.793l0,.012,9.746,4.013,41.85,14.332,5.16-4.013Z",
    transform: "translate(-113.74 -280.663)",
    fill: "#ffb9b9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M251.2,406.015l-12.613,8.026H223.679l-69.368-25.8L52.837,406.588,49.971,384.8l92.874-40.7,81.408,26.945Z",
    transform: "translate(-7.354 -50.639)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 22.358,
    cy: 22.358,
    r: 22.358,
    transform: "translate(194.54 171.348)",
    fill: "#ffb9b9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M392.542,552.638a128.461,128.461,0,0,1-6.3,39.733l-1.675,5.151-8.026,36.691-8.6,2.293-6.306-8.026-12.612-9.173L339.851,604.4,331.985,591.3l-2.454-4.093-8.6-43L288.254,525.86l-10.893-1.72,2.293-6.306,9.746-13.186,9.746-1.147,2.866-2.293,2.293,1.147,12.641,4.87,40.985-17.316,6,.98,20.639,17.2A128.351,128.351,0,0,1,392.542,552.638Z",
    transform: "translate(-117.793 -269.664)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M303.844,321.2l-21.785,14.332-32.517,29.318-2.454-4.093-6.88-34.4h1.72L259.7,293.683Z",
    transform: "translate(-35.35 -43.219)",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M256.635,289.649l-17.772,32.677-10.319,11.466-9.172,2.293,24.651,26.945L278.993,331.5l21.785-14.333Z",
    transform: "translate(-32.283 -42.626)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M322.853,436.273l-2.423.932a3.382,3.382,0,0,1-.9-4.7l.04-.057-4.477-.209a33.8,33.8,0,0,1,50.465-4.068c.2-.7,2.426.664,3.333,2.049.3-1.142,2.388,4.38,3.125,8.283.341-1.3,1.653.8.5,2.812.728-.106,1.057,1.756.493,2.794.8-.374.662,1.849-.2,3.335,1.137-.1-.1,23.309-17.154,21.6-1.187-5.456-.853-5.117-2.251-12.133-.651-.691-1.364-1.32-2.075-1.948l-3.849-3.4c-4.475-3.95-8.546-8.825-14.508-10.3-4.1-1.015-6.687-1.244-4.455-5.86-2.017.842-3.9,2.094-5.936,2.876C322.608,437.64,322.893,436.917,322.853,436.273Z",
    transform: "translate(-123.345 -259.19)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 4.013,
    cy: 4.013,
    r: 4.013,
    transform: "translate(224.065 192.273)",
    fill: "#ffb9b9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 18.43,
    height: 18.43,
    transform: "translate(39.71 119.896) rotate(-86.19)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M124.087,362.131l22.33,1.487-1.487,22.33-22.33-1.487Zm21.294,2.393-20.388-1.358-1.358,20.388,20.388,1.358Z",
    transform: "translate(-95.018 -250.86)",
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 18.43,
    height: 18.43,
    transform: "matrix(0.978, -0.21, 0.21, 0.978, 126.838, 50.849)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M241.5,276.51l4.7,21.88-21.88,4.7-4.7-21.88Zm3.546,21.133-4.292-19.977-19.977,4.292,4.292,19.977Z",
    transform: "translate(-109.296 -238.26)",
    fill: "#ccc"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 18.43,
    height: 18.43,
    transform: "matrix(0.73, -0.684, 0.684, 0.73, 112.471, 146.108)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M248.357,383.178l-16.334,15.3-15.3-16.333,16.333-15.3ZM232.068,397.1l14.913-13.968-13.968-14.913L218.1,382.189Z",
    transform: "translate(-108.869 -251.554)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M956.856,231.659H411.562a15.009,15.009,0,0,0-15.009,15.009V550.493A15.009,15.009,0,0,0,411.562,565.5H956.856a15.009,15.009,0,0,0,15.009-15.009V246.668a15.009,15.009,0,0,0-15.009-15.009Z",
    transform: "translate(-135.333 -231.659)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 535.062,
    height: 301.83,
    transform: "translate(281.342 26.524)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 5.488,
    cy: 5.488,
    r: 5.488,
    transform: "translate(542.928 7.317)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M711.934,332.932H329.89V31.1Z",
    transform: "translate(-48.548 -4.577)",
    fill: "#f2f2f2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 51.432,
    cy: 51.432,
    r: 51.432,
    transform: "translate(313.632 202.905)",
    fill: "#16c389"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M520.7,553.131a63.976,63.976,0,1,1,63.976-63.976A63.976,63.976,0,0,1,520.7,553.131Zm0-127.116a63.14,63.14,0,1,0,63.14,63.14,63.14,63.14,0,0,0-63.14-63.14Z",
    transform: "translate(-144.188 -260.138)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 49.981,
    height: 10.444,
    transform: "translate(642.559 183.334)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 144.553,
    height: 4.476,
    transform: "translate(595.273 126.755)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 144.553,
    height: 4.476,
    transform: "translate(595.273 144.339)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 144.553,
    height: 4.476,
    transform: "translate(595.273 161.925)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 20.888,
    height: 20.887,
    transform: "translate(757.661 44.588)",
    fill: "#16c389"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M1010.143,315.427H984.78V290.064h25.363Zm-24.261-1.1h23.158V291.167H985.884Z",
    transform: "translate(-221.898 -240.254)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M982.938,609.461H930.72V605.7a.746.746,0,0,0-.746-.746h-17.9a.746.746,0,0,0-.746.746v3.762h-11.19V605.7a.746.746,0,0,0-.746-.746h-17.9a.746.746,0,0,0-.746.746h0v3.762H869.549V605.7a.746.746,0,0,0-.746-.746H850.9a.746.746,0,0,0-.746.746h0v3.762h-11.19V605.7a.746.746,0,0,0-.746-.746h-17.9a.746.746,0,0,0-.746.746v3.762h-11.19V605.7a.746.746,0,0,0-.746-.746h-17.9a.746.746,0,0,0-.746.746h0v3.762H777.794V605.7a.746.746,0,0,0-.746-.746h-17.9a.746.746,0,0,0-.746.746h0v3.762H747.208V605.7a.746.746,0,0,0-.746-.746H606.217a.746.746,0,0,0-.746.746h0v3.762h-11.19V605.7a.746.746,0,0,0-.746-.746h-17.9a.746.746,0,0,0-.746.746h0v3.762H563.7V605.7a.746.746,0,0,0-.746-.746h-17.9a.746.746,0,0,0-.746.746h0v3.762h-11.19V605.7a.746.746,0,0,0-.746-.746h-17.9a.746.746,0,0,0-.746.746h0v3.762h-11.19V605.7a.746.746,0,0,0-.746-.746h-17.9a.746.746,0,0,0-.746.746h0v3.762h-11.19V605.7a.746.746,0,0,0-.746-.746h-17.9a.746.746,0,0,0-.746.746v3.762H441.356V605.7a.746.746,0,0,0-.746-.746h-17.9a.746.746,0,0,0-.746.746h0v3.762H387.646a17.9,17.9,0,0,0-17.9,17.9v8.1a17.9,17.9,0,0,0,17.9,17.9H982.938a17.9,17.9,0,0,0,17.9-17.9v-8.1a17.9,17.9,0,0,0-17.9-17.9Z",
    transform: "translate(-131.388 -286.594)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.e024dc39513b1c1d9c287fcd2c937338.svg";
export { ForwardRef as ReactComponent };